// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/locazioni?societaId=&sedeId=&fornitoreId=&q=&attivo=',
    requestBody: null,
    response: '{"success":true,"data":[{...locazione}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
